import { render } from "./BaliseInfo.vue?vue&type=template&id=bd87fc3a"
import script from "./BaliseInfo.vue?vue&type=script&lang=js"
export * from "./BaliseInfo.vue?vue&type=script&lang=js"

import "./BaliseInfo.vue?vue&type=style&index=0&id=bd87fc3a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__